import urlResolver from 'admin/utils/URLResolver';
import useSWRImmutable from 'swr/immutable';
import { CourseProduct } from 'edrolo/domains/coursePortal/types/Courses';

export interface IUseCourses {
  data: CourseProduct[];
  loading: boolean;
  error: Error | undefined | unknown;
}

export const useCourses = (features?: string[]) => {
  const myCoursesUrl = urlResolver.reverse('api:my-courses');

  // Filter courses to those granting a set of CourseFeatures (e.g. features=['TASK_SETTING', ...]).
  // Used by task setting to ensure that only courses with the TASK_SETTING feature are accessible
  // in the tasks UI.
  const myCoursesWithFeaturesUrl = urlResolver.query('api:my-courses', null, {
    features,
  });

  const url = features?.length ? myCoursesWithFeaturesUrl : myCoursesUrl;

  const { data, error } = useSWRImmutable(url);

  if (error) {
    console.error(error);
  }

  return {
    data,
    error,
    loading: !data && !error,
  };
};
